import Tooltip from "PFComponents/tooltip/tooltip";
import InfoIconSVG from "PFIcons/info.svg";
import React from "react";

import css from "./box_tooltip.module.scss";

const InfoIcon = (props) => <InfoIconSVG {...props} />;

type BoxTooltipProps = {
  content: string;
};

const BoxTooltip = ({ content }: BoxTooltipProps) => (
  <Tooltip content={content}>
    <div className={css.infoIcon}>
      <InfoIcon height={20} width={20} />
    </div>
  </Tooltip>
);

export default BoxTooltip;
